import React from 'react';

const Header = () => {
    return (
        <div className="section-title-block">
            <h2 className="section-title">Resume</h2>
            <h5 className="section-description">4+ Years of Experience</h5>
        </div>
    );
};

export default Header;